import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';

import GridContainer from 'Common/Grid/GridContainer.jsx';
import Clearfix from 'Common/Clearfix/Clearfix.jsx';
import ItemGrid from 'Common/Grid/ItemGrid.jsx';
import Button from 'Common/CustomButtons/Button';
import { CustomFormInput } from 'Common/Form';
import { FormStatusSelect, FormMonthSelect } from 'Common/ReduxForm';
import { requiredValidation, isYearValidation, maxLengthValidation } from 'Utils';
import FormGroup from 'Components/FormGroup/FormGroup';

const maxLength255 = maxLengthValidation(255);

const styles = theme => ({
    field: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
    },
});

@reduxForm({
    form: 'journalData',
    enableReinitialize: true,
})
class JournalForm extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        pristine: PropTypes.bool,
        submitting: PropTypes.bool,
        initialValues: PropTypes.object,
        classes: PropTypes.object.isRequired,
        journalId: PropTypes.string,
    };

    render() {
        const { handleSubmit, pristine, submitting, journalId } = this.props;

        return (
            <form onSubmit={handleSubmit} id="journal.data" className="form-wrapper">
                <FormGroup required>
                    <GridContainer>
                        {journalId ? (
                            <ItemGrid xs={12} sm={12} md={6}>
                                <div className="disabled-field-wrapper">
                                    <Field
                                        name="id"
                                        rowClassName="mm-form-field"
                                        component={CustomFormInput}
                                        type="text"
                                        label="journal-id"
                                        withLabel={true}
                                        input={{ disabled: true, value: journalId }}
                                        required={false}
                                    />
                                </div>
                            </ItemGrid>
                        ) : (
                            <div />
                        )}
                        {journalId ? <ItemGrid xs={12} sm={12} md={6} /> : <div />}
                        <ItemGrid xs={12} sm={12} md={6}>
                            <Field
                                name="title"
                                rowClassName="mm-form-field"
                                component={CustomFormInput}
                                type="text"
                                label="title"
                                validate={[maxLength255]}
                                placeholder="title"
                                withLabel={true}
                            />
                        </ItemGrid>
                        <ItemGrid xs={12} sm={12} md={6}>
                            <Field
                                name="publisher"
                                rowClassName="mm-form-field"
                                component={CustomFormInput}
                                type="text"
                                label="publisher"
                                validate={[maxLength255]}
                                placeholder="publisher"
                                withLabel={true}
                            />
                        </ItemGrid>
                        <ItemGrid xs={12} sm={12} md={6}>
                            <Field
                                name="founder"
                                rowClassName="mm-form-field"
                                component={CustomFormInput}
                                type="text"
                                label="founder"
                                placeholder="founder"
                                withLabel={true}
                                validate={[maxLength255]}
                            />
                        </ItemGrid>
                        <ItemGrid xs={12} sm={12} md={6}>
                            <Field
                                name="issn_print"
                                rowClassName="mm-form-field"
                                component={CustomFormInput}
                                type="text"
                                label="issn_print"
                                placeholder="issn_print"
                                withLabel={true}
                                validate={[maxLength255]}
                            />
                        </ItemGrid>
                        <ItemGrid xs={12} sm={12} md={6}>
                            <Field
                                name="issn_online"
                                rowClassName="mm-form-field"
                                component={CustomFormInput}
                                type="text"
                                label="issn_online"
                                placeholder="issn_online"
                                withLabel={true}
                                validate={[maxLength255]}
                            />
                        </ItemGrid>
                        <ItemGrid xs={12} sm={12} md={3}>
                            <Field
                                name="issued_since_month"
                                rowClassName="mm-form-field"
                                component={FormMonthSelect}
                                withLabel={true}
                                label="issued_since_month"
                                placeholder="issued_since_month"
                                validate={[requiredValidation]}
                            />
                        </ItemGrid>
                        <ItemGrid xs={12} sm={12} md={3}>
                            <Field
                                name="issued_since_year"
                                rowClassName="mm-form-field"
                                component={CustomFormInput}
                                type="number"
                                label="issued_since_year"
                                placeholder="issued_since_year"
                                withLabel={true}
                                validate={[isYearValidation]}
                            />
                        </ItemGrid>
                        <ItemGrid xs={12} sm={12} md={12}>
                            <Field
                                withLabel
                                name="is_active"
                                label="is_active"
                                rowClassName="mm-form-field"
                                placeholder="is_active"
                                component={FormStatusSelect}
                                required={false}
                            />
                        </ItemGrid>
                        <ItemGrid xs={12} sm={12} md={12} />
                    </GridContainer>
                </FormGroup>
                <Button color="success" right type="submit" disabled={pristine || submitting}>
                    <FormattedMessage id={journalId ? 'button.journal.update' : 'button.journal.create'} />
                </Button>
                <Clearfix />
            </form>
        );
    }
}

export default withStyles(styles)(JournalForm);



// WEBPACK FOOTER //
// ./src/layouts/Journal/JournalForm.jsx